import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SxHttpService } from './sxHttp.service';
import { of } from 'rxjs/observable/of';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

/**
 * Representa un PanelGrupoConItemsVM en el backend
 */
export interface ListadaAgrupada extends PanelGrupoVM {
  items: PanelItemVM[];
  subcat: string;
}

/**
 * Representa un PanelGrupoConItemsVM en el backend
 */
export interface PanelGrupoConItemsVM extends PanelGrupoVM {
  items: PanelItemVM[];
}

/**
 * Representa un PanelGrupoVM en el backend
 */
export interface PanelGrupoVM {
  codigo: string;
  nombre: string;
}

/**
 * Representa un PanelItemVM en el backend
 */
export interface PanelItemVM {
  nombrePanel: string;
  descripcion: string;
  tipo: string;
  id: string;
  url: string;
}


export interface RootConfigurationItem {
  targetRelativeUrl: string;
  titleCode: string;
  icon: string;
  descriptionCode: string;
}

@Injectable()
export class ConfigService {
  private configUrl = 'api/configuracion';
  private gruposUrl = this.configUrl + '/Grupos';
  private itemsUrl = this.configUrl + '/Items';

  constructor(private sxHttp: SxHttpService) { }

  /**
  * Dado un sistema, un negocio y un producto,
  * obtiene los grupos junto con sus items desde el backend.
  */
  getConfiguracion(condOrganization = null, codSistema = null, codNegocio = null, codProducto = null, level = null, levelData = null): Observable<ListadaAgrupada[]> {
    let url = `${this.configUrl}/Configuracion/${condOrganization}/${codSistema}/${codNegocio}/${codProducto}/${level}`;
    if (levelData) {
      url += `/${levelData}`;
    }
    return this.sxHttp.get(url)
      .map(response => response.json().data as ListadaAgrupada[]);
  }

  /**
   * Dado un sistema, un negocio y un producto,
   * obtiene los grupos desde el backend.
   */
  getGrupos(codOrganization, codSistema, codNegocio, codProducto): Observable<PanelGrupoVM[]> {
    const url = `${this.gruposUrl}/${codOrganization}/${codSistema}/${codNegocio}/${codProducto}`;
    return this.sxHttp.get(url)
      .map(response => response.json().data as PanelGrupoVM[]);
  }

  /**
   * Obtiene los items de un grupo desde el backend.
   */
  getItems(codOrganization, codSistema, codNegocio, codProducto, codGrupo): Observable<PanelItemVM[]> {
    const url = `${this.itemsUrl}/${codOrganization}/${codSistema}/${codNegocio}/${codProducto}/${codGrupo}`;
    return this.sxHttp.get(url)
      .map(response => response.json().data as PanelItemVM[]);
  }

  getInitializerExport(codSistema): Observable<any> {
    const url = `${this.configUrl}/InitializerExport/${codSistema}`;
    return this.sxHttp.get(url)
      .map(response => response.json().data as any);
  }

  // Methods for lazy loading
  getExportNode(treeViewKey: any, nodeChecked: boolean) {
    const url = `${this.configUrl}/InitializerExport/GetNode/${nodeChecked}`;
    return this.sxHttp
      .post(url, treeViewKey)
      .map(response => response.json().data);
  }

  postInitializerExportCreateFile(request: any): Promise<any> {
    const url = `${this.configUrl}/InitializerExport/CreateFile`;
    return this.sxHttp.post(url, request)
      .map(response => response.json().data as any)
      .toPromise();
  }

  postInitializerExportSystemTablesCreateFile(codSistema: string): Promise<any> {
    const url = `${this.configUrl}/InitializerExport/ExportarTablasDelSistema/${codSistema}`;
    return this.sxHttp.post(url, {})
      .map(response => response.json().data as any)
      .toPromise();
  }

  getInitializerExportDownloadFile(tempFileName: any): Observable<any> {
    const url = `${this.configUrl}/InitializerExport/DownloadFile`;
    return this.sxHttp.get(url, { tempFileName })
      .map(response => response.json().data as any);
  }

  postInitializerImport(formData: FormData, codSistema: string): Promise<any> {
    const url = `${this.configUrl}/InitializerImport/${codSistema}`;
    const headers = new Headers();
    return this.sxHttp.post(url, formData, {}, headers)
      .map(response => response.json().data as any)
      .toPromise();
  }

  getHistorialImportacion(codSistema: string): Observable<any> {
    const url = `${this.configUrl}/HistorialImportacion/${codSistema}`;

    return this.sxHttp.get(url)
      .map(res => res.json().data as any);
  }

  aplicarVersion(codSistema, historialId): Promise<boolean> {
    const url = `${this.configUrl}/HistorialImportacion/${codSistema}/${historialId}`;
    return this.sxHttp.put(url, null)
      .toPromise()
      .then(res => res.json().data);
  }

  getRootConiguration(): Observable<RootConfigurationItem[]> {
    const url = `${this.configUrl}/GetRootConfiguration`;

    return this.sxHttp.get(url)
      .map(res => res.json().data as RootConfigurationItem[]);
  }

  getRootUserManagementConiguration(): Observable<RootConfigurationItem[]> {
    const url = `${this.configUrl}/GetRootUserManagementConfiguration`;

    return this.sxHttp.get(url)
      .map(res => res.json().data as RootConfigurationItem[]);
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/config.service.ts